import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { featherCalendar } from '@ng-icons/feather-icons';
import { CompaniaPaqueteService } from 'src/app/api/services/company-package.service';
import { LoadingComponent } from 'src/app/shared/component/loading/loading.component';
import { CompanyPackage, Paquete } from 'src/app/shared/model/package';
import { DateLongPipe } from 'src/app/shared/pipe/date-long.pipe';
import { DaysRemainingPipe } from 'src/app/shared/pipe/days-remaining.pipe';

@Component({
  selector: 'app-company-package',
  imports: [
    CommonModule,
    NgIcon,
    DateLongPipe,
    DaysRemainingPipe,
    LoadingComponent
  ],
  templateUrl: './company-package.component.html',
  viewProviders: [provideIcons({ featherCalendar })]
})
export class CompanyPackageComponent {
  idCompany!: string;
  paquetes: CompanyPackage[] = [];
  isLoading: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private cpService: CompaniaPaqueteService
  ) { }

  ngOnInit(): void {
    this.route.parent?.params.subscribe(params => {
      this.idCompany = params['id'];
      if (this.idCompany) {
        this.loadActivePackages();
      }
    });
  }

  loadActivePackages() {
    this.isLoading = true;

    this.cpService.getActivesByIdCompany(this.idCompany).subscribe(res => {
      this.paquetes = res.dto.packages;
      this.isLoading = false;
    });
  }

  explorarPaquetes() {
    this.router.navigate([`/user/company/${this.idCompany}/packages`]);
  }
}
